const fullpage = require("fullpage.js");

const instance = new fullpage("#fullpage", {
    normalScrollElements: ".cbp-hrsub",

    navigation: true,

    lazyLoading: false,

    navigationPosition: "left",

    // licenseKey: "17119E4E-E1434AB4-B2214CBE-B2F15CCA",

    afterLoad: function (dest, origin) {
        $(".fullpage__prev").css("display", origin.isFirst ? "none" : "block");
        $(".fullpage__next").css("display", origin.isLast ? "none" : "block");
    },
});

$(".fullpage__prev").on("click", function () {
    instance.moveSectionUp();
});

$(".fullpage__next").on("click", function () {
    instance.moveSectionDown();
});

window.fullpage_api = instance;
